import React from 'react'
import { CampaignGigOption, Gig, GigType } from '../../../../types/collaborations/CollaborationTypes'
import CampaignGig from '../components/CampaignGig'
import { StoreSelection } from './Stores'

interface CampaignGigsProps {
    gigs: Gig[],
    onPlayButtonClick: (gig: Gig) => void,
    onSelect: (gig: Gig) => void,
    gigType: GigType,
    selectedGigs: (string | number)[],
    options?: Record<string | number, CampaignGigOption[]> | null,
    setOptions?: (options: Record<string | number, CampaignGigOption[]> | null) => void
}

const CampaignGigs: React.FC<CampaignGigsProps> = ({ gigs, onPlayButtonClick, onSelect, gigType, selectedGigs, options, setOptions }) => {
    return (
        <>
            {
                gigType.slug === 'store_visit' ? (
                    <StoreSelection
                        gigs={gigs}
                        onSelect={onSelect}
                        selectedGigs={selectedGigs}
                    />
                ) : (
                    <div className="gigs-list">
                        {
                            gigs.map((gig, i) => {
                                return (
                                    <div className="gig-item" key={i}>
                                        <div className="gig-selection-checkbox-wrapper">
                                            <input type='checkbox' checked={selectedGigs.includes(gig.id)} onChange={(e: any) => {
                                                onSelect(gig)
                                                if(e.target.checked && Array.isArray(gig.options) && gig.options.length){
                                                    const gigOptions = gig.options ? gig.options.map((opt) => ({...opt, values:  (Array.isArray(opt.values) && opt.values.length) ? [opt.values[0]] : []})) : [];
                                                    let updatedOptions = {...options, [gig.id]:  gigOptions}
                                                    setOptions?.(updatedOptions);
                                                }
                                            }} className='form-check-input gig-selection-check-input' />
                                        </div>
                                        <CampaignGig
                                            enableOptionsSelection={selectedGigs.includes(gig.id)} 
                                            selectedOptions={options?.[gig.id] ? options[gig.id] : []}
                                            onOptionSelection={(data: CampaignGigOption[]) => {
                                                let updatedGigOptions = { ...options, [gig.id]: data };
                                                setOptions?.(updatedGigOptions);
                                            }} gigType={gigType.slug} gig={gig} onPlayBtnClick={onPlayButtonClick} />
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
        </>
    )
}

export default CampaignGigs